// extracted by mini-css-extract-plugin
export default {"linkedInBtn":"styles_linkedInBtn__rpkR0"};